import { Grid } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import BusinessInvoicesEmitted from './components/emittedInvoices';
import BusinessInvoicesReceived from './components/receivedInvoices';

const BusinessInvoices = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <BusinessInvoicesEmitted id={id} />
      </Grid>
      <Grid item xs={12}>
        {id && <BusinessInvoicesReceived />}
      </Grid>
    </Grid>
  );
};

export default BusinessInvoices;
